/* eslint-disable */
/** 
 * This file contains language specific message functions for tree-shaking. 
 * 
 *! WARNING: Only import messages from this file if you want to manually
 *! optimize your bundle. Else, import from the `messages.js` file. 
 * 
 * Your bundler will (in the future) automatically replace the index function 
 * with a language specific message function in the build step. 
 */


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__add = () => `Hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back = () => `Zurück`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_home = () => `Zurück zur Homepage`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_overview = () => `Zurück zur Übersicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__back_to_search = () => `Zurück zur Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__close_panel = () => `Schließe das Panel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__delete = () => `Löschen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__edit = () => `Ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__modify = () => `Ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__open_panel = () => `Das Panel öffnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__print = () => `Drucken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__retry = () => `Wiederholen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__save = () => `Speichern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_in = () => `Anmeldung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__sign_up = () => `Registrierung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const action__validate = () => `Bestätigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__article_button = () => `Artikel lesen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__badge_text = () => `Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__button_label = () => `Reisen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__first_line = () => `Unsere Top-Reiseziele und alle unsere Reiseinspirationen sind in`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_button = () => `Entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_subtitle = () => `Entdecken Sie unsere Reisetipps im Magazine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__generic_title = () => `Auf der Suche nach Inspiration?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ad__magazine__second_line = () => `das ViaMichelin-Magazin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__detail = () => `Diese Information ist nicht verfügbar.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const address__summary__error__title = () => `Der Ort wurde nicht gefunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__close_button__label = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__no_events__label = () => `In diesem Gebiet gibt es derzeit keine Meldungen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const alerts_traffic_panel__select_location__label = () => `Um Meldungen anzuzeigen, geben Sie einen Ort in das Suchfeld ein.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__add__itinerary = () => `Diese Route zu meinen Favoriten hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_car = () => `Auto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_caravan = () => `Wohnwagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_electricCar = () => `Elektrisches Auto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__badge_motorcycle = () => `Motorrad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__delete_favorite_ariaLabel = () => `Route löschen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite__routes = () => `Bevorzugten Routen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached = () => `Sie haben die Höchstzahl an bevorzugten Routen erreicht.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__favorite_limit_reached__cta = () => `Favoriten anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__find_favorites_routes = () => `Meine bevorzugten Routen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_deleted__success = () => `Route aus Ihren Favoriten entfernt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error = () => `Die Route konnte nicht zu den Favoriten hinzugefügt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__iti_save_error__cta = () => `Versuchen Sie es später noch einmal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary__saved = () => `Gespeicherte Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__itinerary_saved = () => `Route zu den Favoriten hinzugefügt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__no_saved_itineraries = () => `Keine Route in den Favoriten gespeichert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__save_favorite_route = () => `Speichern Sie Ihre bevorzugten Routen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see = () => `Favoriten anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__see_favorite_route = () => `Route anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_actions = () => `Aktionen (Route löschen oder ansehen)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__table_head_iti_details = () => `Details der Route (Start, Ziel, Zwischenziele)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const bookmark__via = () => `Über`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__placeholder = () => `Ankunft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = () => `Wählen Sie ein Ankunftsdatum aus.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__cancel = () => `Löschen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const calendar__validate = () => `Bestätigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__arrival_placeholder = () => `Datum der Ankunft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__close_aria_label = () => `Ausgewählte Daten löschen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__departure_placeholder = () => `Abreise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__one = () => `nacht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__night_count_placeholder__other = () => `nächte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const date_range_picker__trigger_aria_label = () => `Start und Enddatum mithilfe des Kalender-Widgets auswählen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = () => `zurück zur Startseite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__or = () => `oder`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_end = () => `wenn Sie nicht finden, was Sie suchen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__text_start = () => `Sie können`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__404__title = () => `Diese Seite wurde gelöscht oder geändert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_end = () => `für Hilfe.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__text_start = () => `Unser Team arbeitet an der Lösung des Problems. Sie können es später noch einmal versuchen oder`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__500__title = () => `Diese Seite konnte nicht geladen werden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const error__contact_us = () => `uns kontaktieren`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__many = (params) => `${params.count} Plätze`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const ev_spots__one = () => `1 Platz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const favoriteItineraries__deleteError = () => `Diese Route konnte nicht aus den Favoriten entfernt werden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__faq_title = () => `Häufig gestellte Fragen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__magazine_button = () => `Das Info-Magazin ViaMichelin durchsuchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const footer__newsletter_button = () => `Unseren Newsletter abonnieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B10 = () => `Premium Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__B7 = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__CNG = () => `Methan`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E10 = () => `SP 95 - E10`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5 = () => `SP 95`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E5_98 = () => `SP 98`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__E85 = () => `Ethanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__H2 = () => `H2`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const gas_station__fuel_label__LPG = () => `LPG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const highways = () => `Autobahnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const input__clear = () => `Eingabe löschen`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__ad__loading = (params) => `Berechne Routen in ${params.count} s`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__add_step = () => `Etappe hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__compute = () => `Eine Route suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__current_location = () => `Ihr aktueller Standort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__edit = () => `Ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__invert = () => `Umkehren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__max_steps_reached = () => `Max. Etappenzahl erreicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__edit = () => `Fahrzeug ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__register = () => `Ihr Fahrzeug hinzufügen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_badge__user = () => `Mein Fahrzeug`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__bifuel = () => `Bi-Fuel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__cng = () => `Erdgas`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__diesel = () => `Diesel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__electric = () => `Elektrisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__ethanol = () => `Ethanol`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__gasoline = () => `Benzin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hybrid = () => `Hybrid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__hydrogen = () => `Wasserstoff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_energy__lpg = () => `LPG`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__city = () => `Kleinwagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__compact = () => `Kompakt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__saloon = () => `Limousine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__sports = () => `Coupé`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__car_type__suv = () => `SUV`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle = () => `Sie fahren mit einem Wohnwagen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__caravan_toggle_helper_text = () => `Passt die Daten zu Kosten, Fahrzeit und Verbrauch an, aber nicht die Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__error = () => `Die Fahrzeuge konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__cars__retry = () => `Wiederholen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_border_crossing = () => `Das Land nicht verlassen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_ferry = () => `Fähren meiden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_low_emission_zone = () => `Umweltzonen meiden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_motorway = () => `Autobahnen meiden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_toll = () => `Mautstraßen meiden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__no_vignette = () => `Ohne Vignette`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__constraints__none = () => `Keine`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency = () => `Währung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__chf = () => `CHF - Schweizer Franken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__czk = () => `Kč - Tschechische Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__dkk = () => `kr - Dänische Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__eur = () => `€ - Euro`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__gbp = () => `£ - Britisches Pfund`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__hrk = () => `kn - Kroatische Kuna`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__huf = () => `Ft - Ungarischer Forint`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__jpy = () => `¥ - Japanischer Yen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__nok = () => `kr - Norwegische Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__pln = () => `zł - Polnischer Zloty`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__sek = () => `kr - Schwedische Krone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__uah = () => `₴ - Ukrainische Hrywnja`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__currency__usd = () => `$ - US-Dollar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__distance_unit = () => `Längeneinheit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__ev_toggle = () => `Sie fahren ein E-Auto`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__fuel__price = () => `Preis pro Liter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__kwh__price = () => `Preis pro kWh`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__bike = () => `Fahrrad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car = () => `Pkw`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit = () => `Fahrzeug laden, wenn Sie … erreichen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__car_ev_limit_warning_message = () => `Verschiedene Faktoren (Temperatur, Wind, Anzahl der Passagiere...) können die Reichweite Ihres E-Autos beeinflussen. Wir empfehlen, einen Puffer einzuplanen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__motorcycle = () => `Motorrad`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__modes__walk = () => `Zu Fuß`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__title = () => `Einstellungen für Ihre Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__traffic_toggle = () => `Vermeiden von Staus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__travel_mode = () => `Ihr Verkehrsmittel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__trip_constraint = () => `Ihre Routeneinstellungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__imperial = () => `Meilen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__options__units__metric = () => `Kilometer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__recompute = () => `Eine Route suchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const itinerary__summary__traffic_avoided_badge = () => `Vermiedener Verkehr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__restStop__description = () => `empfiehlt diesen Bereich für Familien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kleber__village__description = () => `empfehlen dieses Zwischenstopp Dorf für Familien`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_add_car = () => `Fügen Sie Ihr Fahrzeug für genauere Kostenschätzungen hinzu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create = () => `Erstellen Sie Ihr Konto in nur wenigen Klicks`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_create_account = () => `Ein Konto erstellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_ideas = () => `Tanken Sie Ideen: Entdecken Sie unsere Top-Reiseziele und Roadtrips dank`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_more = () => `Mehr erfahren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_newsletter = () => `unseren Newsletter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_save_pref = () => `Speichern Sie Ihre Routenpräferenzen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__account_modal_signin = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_cta_label = () => `Berechnen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_notification = () => `Geben Sie einen Start und ein Ziel ein, um die detaillierten Kosten der Route zu sehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__cost_title = () => `Die detaillierten Kosten für Ihre Fahrten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__headline_title = () => `Auf ViaMichelin finden Sie ...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_cta_label = () => `Besuchen Sie das Mag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__magazine_title = () => `Inhalte, die Sie inspirieren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__pois_hrt = () => `Sehenswürdigkeiten ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_cta_label = () => `Auswahl entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__selection_title = () => `Die gesamte Michelin-Auswahl`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_cta_label = () => `Entdecken Sie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_notification = () => `Geben Sie einen Start und eine Ankunft ein, um die vorgeschlagenen Zwischenstopps zu finden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const launchpad__zois_title = () => `Ideen für Zwischenstopps auf Ihrer Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__header = () => `Kartentyp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__image_alt = () => `Klassische Karte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__historic__label = () => `Klassisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__image_alt = () => `Hybride Karte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__hybrid__label = () => `Hybrid`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__imagex_alt = () => `Michelin-Karte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__michelin__label = () => `Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__imagex_alt = () => `Panoramastraßen-Karte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const layers__scenic__label = () => `Panoramastraßen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__confidentiality_policy = () => `Persönliche Daten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__contact = () => `Kontaktieren Sie uns`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = () => `Cookies`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__credits = () => `Impressum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__legal_notice = () => `Rechtliche Hinweise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__term_of_use = () => `Nutzungsbedingungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__error = () => `Wir können Ihren Standort nicht genau ermitteln.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__header = () => `Die Standortermittlung ist deaktiviert`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const location_control__tooltip__text = () => `Ändern Sie Ihre Browser-Einstellungen, um den Zugriff auf Ihren Standort zuzulassen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__failure = () => `Bei der Anmeldung ist ein Fehler aufgetreten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__success = () => `Sie wurden erfolgreich angemeldet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__access_profile = () => `Zu meinem Profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__compass = () => `Kompass`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__location = () => `Ort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__login_profile = () => `Sich mit meinem Profil verbinden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__profile = () => `Profil`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__settings = () => `Einstellungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_in = () => `Vergrößern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__aria_labels__zoom_out = () => `Verkleinern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel = () => `Hotels`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_controls__partner_hotel__long_label = () => `Eine Unterkunft finden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__go_to_traffic_info_page__label = () => `Warnmeldungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__low_emission_zone__label = () => `Umweltzone`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info__label = () => `Anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_busy__label = () => `Dicht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_closed_lane__label = () => `Gesperrte Straße`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_display_alerts__label = () => `Warnmeldungen anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_fluid__label = () => `Flüssig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const map_tools__traffic_info_heavy__label = () => `Stau`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__bookTheFork = () => `Buchungs-Widget TheFork`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__close = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const modal__locale_switch_title = () => `ViaMichelin gibt es in mehreren Sprachen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const other_roads = () => `Andere Wege`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__first = () => `Erste Seite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__last = () => `Letzte Seite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__nav = () => `Seiten-Navigation`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__next = () => `Nächste Seite`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page = (params) => `Seite ${params.page}`


/**
 * @param {{ page: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__page_active = (params) => `Seite ${params.page}, aktuelle Seite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__aria_labels__prev = () => `Vorherige Seite`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__end_of_results = () => `Ende der Ergebnisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__next = () => `Weiter zu`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const pagination__previous = () => `Vorherige`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poiCard__seeDetails = () => `Details ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__activities = () => `Aktivitäten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__add_to_itinerary = () => `Schritt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__book = () => `Buchen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__cancel = () => `Abbrechen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__details = () => `Details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_actions__itinerary = () => `Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__actions_book = () => `Reservieren`


/**
 * @param {{ average: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__average_price = (params) => `Etwa ${params.average}`


/**
 * @param {{ price: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__book_min_price = (params) => `Reservierung ab ${params.price}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__aria_label = () => `Bildkarussell für`


/**
 * @param {{ current: NonNullable<unknown>, total: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__list_aria_label = (params) => `bild ${params.current} auf ${params.total}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__next_button = () => `Nächsten Inhalt ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__carousel__prev_button = () => `Vorherigen Inhalt ansehen`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__many = (params) => `Max. ${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__charging_power__one = (params) => `${params.count} kW`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__count_more_than_3_connectors = (params) => `+ ${params.count} mehr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__image_alt = () => `Bild des Orts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__michelin = () => `Guide Michelin`


/**
 * @param {{ min: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__min_price = (params) => `Ab ${params.min}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__non_availability = () => `Ausgebucht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_tag_average = () => `Etwa`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__price_unavailable = () => `Preis nicht verfügbar`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__bad = () => `Schlecht`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__disappointing = () => `Enttäuschend`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__exceptional = () => `Außergewöhnlich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__fabulous = () => `Fabelhaft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__good = () => `Gut`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__mediocre = () => `Mittelmäßig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__passable = () => `Passabel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__pleasant = () => `Angenehm`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__quite_mediocre = () => `Recht mittelmäßig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__superb = () => `Hervorragend`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__very_good = () => `Sehr gut`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review__well = () => `Gut`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__review_count = (params) => `${params.count} Bewertungen`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_card__updated = (params) => `am ${params.date}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__accommodation = () => `Unterkünfte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__ev_service = () => `Ladestationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__gas_station = () => `Tankstellen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__parking = () => `Parkplätze`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__rest_stop = () => `Rastplätze`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__restaurant = () => `Restaurants`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_categories__tourism = () => `Tourismus`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__header = () => `Interessante Orte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__not_available = () => `Sonderziele können auf dieser Seite nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__select_all = () => `Alles anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_category_settings__unselect_all = () => `Alles ausblenden`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__many__overnight_stay = (params) => `Verfügbarkeit für ${params.count} Nächte mit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availabilities__one__overnight_stay = () => `Verfügbarkeit für 1 Nacht mit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability = () => `Aufenthaltsdaten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__error = () => `Die Informationen konnten nicht angezeigt werden.`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__many__other = (params) => `${params.count} weitere Ergebnisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view__one__other = () => `1 weiteres Ergebnis`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__view_more__on_partner_website = () => `Gehen Sie zu Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability__with = () => `Verfügbarkeit mit`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__availability_offer = (params) => `Angebot ${params.count}`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__back_to_list = () => `Zurück zur Liste`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__carousel__close_button = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__description = () => `Mehr Informationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__bb = () => `Bed & Breakfast`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__camping = () => `Campingplatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__hotel = () => `Hotel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__accommodation_subtype__residence = () => `Appartment`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__rest = () => `Rastplatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__highlight__rest_stop__service = () => `Raststätte`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__image_alt = () => `Bild des Orts`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__location = () => `Ort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion = () => `Bewertung des Guide Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__michelin_opinion__tourism = () => `Bewertung des Guide Michelin`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__practical_info = () => `Praktische Hinweise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tour_not_found_with_region_label = () => `Auf GetYourGuide entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found = () => `Die Aktivitäten konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_with_region = () => `Wir haben keine Aktivitäten in der Nähe gefunden, in der Gegend gibt es jedoch ein umfangreiches Angebot.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region = () => `Wir haben keine Aktivitäten in der Nähe gefunden, aber es gibt viele andere in dieser Gegend.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__getyourguide__tours_not_found_without_region_label = () => `Auf GetYourGuide entdecken`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__not_found_image_alt = () => `Bib sucht am Horizont`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__recommendation__title = () => `Das könnte Ihnen gefallen…`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_more = () => `Mehr anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__see_on_map = () => `Auf der Karte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_datasheet__strong_points = () => `Vorteile`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__back = () => `Erweiterte Filter schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__detailed_view__label = () => `Preise, Anzahl der Sterne ... anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__fetch_error = () => `Die Informationen konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__no_selected_categories = () => `Aktivieren Sie eine Kategorie oben für`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__only__michelin = () => `Nur Michelin Empfehlungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__select_to_filter = () => `die entsprechenden Filter anzeigen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__all = () => `Alle`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__many = (params) => `${params.count} ausgewählt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__none = () => `Kein Filter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__selected_items__one = () => `1 ausgewählt`


/**
 * @param {{ hours: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__last_update = (params) => `${params.hours} Std. max.`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_count = (params) => `${params.count} und mehr`


/**
 * @param {{ power: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_power = (params) => `Mind. ${params.power} kW`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__eur = (params) => `${params.amount} € und mehr`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_price__usd = (params) => `$${params.amount} und mehr`


/**
 * @param {{ minRate: NonNullable<unknown>, maxRate: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_rate = (params) => `Mind. ${params.minRate}/${params.maxRate}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__one = (params) => `${params.count} Stern und mehr`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__min_stars__other = (params) => `${params.count} Sterne und mehr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__none = () => `Kein Filter`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__eur = (params) => `${params.amount} €`


/**
 * @param {{ amount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price__usd = (params) => `$${params.amount}`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__eur = (params) => `${params.minAmount} € bis ${params.maxAmount} €`


/**
 * @param {{ minAmount: NonNullable<unknown>, maxAmount: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__price_range__usd = (params) => `$${params.minAmount} bis $${params.maxAmount}`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_filters__value_label__stars = (params) => `${params.count} Sterne`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button = () => `Filter öffnen`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__many = (params) => `${params.numberOfFilters} aktivierte Filter`


/**
 * @param {{ numberOfFilters: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__aria_label__filter_button_filtered__one = (params) => `${params.numberOfFilters} aktivierter Filter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_category = () => `Die interessanten Orte (Hotels, Restaurants …) konnten nicht angezeigt werden:\\nSie müssen mindestens eine Kategorie auswählen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__errors__no_result = () => `Wir haben keine Ergebnisse in dieser Region gefunden. Wiederholen Sie die Suche mit einer erweiterten Suchregion.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_list__filters__toggle_label = () => `Filtern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_marker__pin = () => `Kartennadel`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const poi_search_category__aria_label = () => `Suche`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__close = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__login = () => `Anmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__logout = () => `Abmelden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__favorites__title = () => `Bevorzugten Routen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__banner = () => `Diese Daten sind mit Ihrem Michelin-Konto verknüpft.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__email = () => `E-Mail`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__name = () => `Name`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__form__password = () => `Passwort`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__modify = () => `Auf michelin.com ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__information__title = () => `Kontoinformationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__banner = () => `Sie können diese Einstellungen auch bei der Routensuche ändern.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__title = () => `Einstellungen für die Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const profile__tabs__settings__vehicle = () => `Ihr Fahrzeug`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = () => `Seite neu laden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__construction_year = () => `Jahr`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__fuel = () => `Treibstoff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__text = () => `Wir aktualisieren unsere Datenbank regelmäßig. Wenn Ihr Fahrzeug nicht darin enthalten ist, wählen Sie ein ähnliches Modell oder eines unserer Standardfahrzeuge.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__info_box__title = () => `Sie können Ihr Fahrzeug nicht finden?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register__car__motor = () => `Motorisierung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_subtitle = () => `Um Ihr Fahrzeug hinzuzufügen, müssen Sie ein Michelin-Konto haben.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__account_title = () => `Haben Sie ein Konto?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__fill_to_save = () => `Zum Speichern müssen alle Felder ausgefüllt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_error = () => `Beim Speichern ist ein Fehler aufgetreten. Könnten Sie den Vorgang bitte wiederholen?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__register_success = () => `Ihr Fahrzeug wurde gespeichert.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = () => `Fahrzeugmarke und -modell`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const register_car__vehicle = () => `Fahrzeug`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__dogArea = () => `Hundebereich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__nursery = () => `Kindergarten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__picnicTable = () => `Picknicktisch`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__playGround = () => `Spielplatz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__restaurant = () => `Restaurant`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restStopService__shop = () => `Shop`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const restaurantMichelin_greenStarLabel = () => `Nachhaltige Gastronomie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const road_typology = () => `Straßentypologie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__arrival = () => `Ankunft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__alternative = () => `Alternativ`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__discovery = () => `Entdeckung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__ecological = () => `Umweltschonend`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__economic = () => `Günstig`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__quickest = () => `Schnell`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__badge__shortest = () => `Kurz`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__departure = () => `Abfahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__details = () => `Weiter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__error = () => `Die Informationen konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__final_charge = () => `Ankunft in`


/**
 * @param {{ tollCost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__included_costs = (params) => `davon ${params.tollCost} Maut`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__many = (params) => `${params.count} mögliche Routen`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__itineraries__one = (params) => `${params.count} empfohlene Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__not_found = () => `Es wurde keine Route gefunden. Können Sie Ihre Suche bitte ändern?`


/**
 * @param {{ count: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__recharge = (params) => `${params.count} Ladung(en)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__selected = () => `Beschränkungen auf dieser Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__restrictions_tip__unselected = () => `Voraussichtliche Beschränkungen auf dieser Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_cost = () => `Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_distance = () => `Entfernung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_duration = () => `Dauer`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_electricity_consumption = () => `Verbrauch von Elektrizität`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector__column_emission = () => `CO2-Emissionen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_error_message = () => `Versuchen Sie, Ihre Suche zu ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_address = () => `Unbekannte Orte.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__route_selector_no_road = () => `Keine Route.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__alternative = () => `Markierung der alternativen Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__default = () => `Markierung der Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__discovery = () => `marker auf der Entdeckungsroute`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__ecological = () => `Markierung der umweltschonenden Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__economic = () => `Markierung der günstigen Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__quickest = () => `Markierung der schnellsten Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__routemarkers__ariaLabel__shortest = () => `Marker auf der kürzesten Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route__step = () => `Etappe`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs = () => `Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__costs_details = () => `Einzelaufstellung der Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__electricity = () => `Elektrizität`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__estimated_for = () => `Geschätzte Kosten für`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__fuel = () => `Treibstoff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls = () => `Maut`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__tolls_list = () => `Liste der Mautgebühren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__total_cost = () => `Gesamtkosten der Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__costs_section__vignette = () => `Vignette`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note = () => `Reisekostenabrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__allowance = () => `Pauschale`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__arrival = () => `Ankunft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__back = () => `Zurück zur Reisekostenabrechnung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__costs = () => `Reisekosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__date = () => `Datum`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__departure = () => `Abfahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__distance = () => `Entfernung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data = () => `Weitere Informationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__additional_data_placeholder = () => `Weitere nützliche Informationen.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = () => `Pauschal`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance_input = () => `Vergütung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__compute_method = () => `Berechnungsmethode`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__electricity = () => `Stromkosten (€/kWh)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__fuel = () => `Treibstoffpreis (€/Liter)`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity = () => `Antragsteller`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__identity_placeholder = () => `Vor- und Nachname`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__include = () => `Folgende Elemente berücksichtigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__legal_info = () => `Rechtliche Hinweise`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__real = () => `Reale Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__title = () => `Reisekostenabrechnung ändern`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__travel_date = () => `Datum der Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__electricity = () => `Strom`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__fuel = () => `Treibstoff`


/**
 * @param {{ date: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__generated_on = (params) => `Am ${params.date} auf ViaMichelin erstellt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__identity = () => `Antragsteller`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__notes = () => `Beschreibung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__tolls = () => `Mautgebühren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__total = () => `Gesamt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__travel = () => `Details`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__vignette = () => `Vignetten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions = () => `Anweisungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__instructions__error = () => `Die Navigationsanweisungen konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way = () => `Auf der Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__detour = () => `Unterwegs`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__infos = () => `Entspricht der Entfernung zwischen Ihrer Route und den vorgeschlagenen interessanten Orten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__scope = () => `Suchbereich`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__on_the_way_section__filters__up_to = (params) => `Bis zu ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_details__recommendations = () => `Unsere Tipps`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__cta = () => `Bilden Sie Fahrgemeinschaften`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__description = () => `Durchschnittlicher festgestellter Betrag`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__subtitle = () => `mit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__blablacar__title = () => `Sparen Sie 60€`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__button_label = () => `Detaillierte Kosten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__ev_charging = () => `Energie`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__fuel = () => `Treibstoff`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__title = () => `Kosten für diese Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__detailed_costs__tolls = () => `Mautgebühren`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__on_the_road__title = () => `Auf der Fahrt`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__rest_stop__button_label = () => `Ideen für Zwischenstopps`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__button_label = () => `Roadmap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__emissions = () => `Emissionen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__ev_charging = () => `Nachfüllpackungen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__highway = () => `Schnelle Wege`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_spec_card__roadsheet__title = () => `Roadmap`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__cta_label = () => `Hotels bei der Ankunft ansehen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const route_zoi_hotel__title = () => `Unterkünfte bei der Ankunft`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_label = () => ``


/**
 * @param {{ device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__cta_url = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__description = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__legal_notice = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routecosts__blablacar_card__title = () => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_label = () => ``


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown>, device: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__cta_url = (params) => ``


/**
 * @param {{ cost: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__description = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__legal_notice = () => ``


/**
 * @param {{ departure: NonNullable<unknown>, arrival: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const routeresults__blablacar_card__title = (params) => ``


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search__input__aria_label = () => `Wohin gehen wir?`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__aria_label = () => `Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__button__text = () => `Route`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__empty = () => `Keine Ergebnisse gefunden`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__error = () => `Es ist ein Fehler aufgetreten.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__messages__image_alt = () => `Bib hält Ausschau`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const search_tools__results__aria_label = () => `Suchergebnisse`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const settings__close = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__close_button = () => `Schließen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__loading = () => `Die Abmeldung läuft …`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const sf_logout__logged_out = () => `Sie wurden erfolgreich abgemeldet`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const soon = () => `Demnächst`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_accident = () => `Unfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_dangerous = () => `Gesperrte Straße`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__car_incident = () => `Vorfall`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__construction_cone = () => `Baustelle`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__lane_closed = () => `Verengung`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_event__weather_hail = () => `Unwetter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const traffic_info_settings__header = () => `VERKEHRSBEDINGUNGEN`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__go_to_partner_website = () => `Gehen Sie zu Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__no_room = () => `Keine Verfügbarkeit`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on = () => `Wir haben nur wenige Unterkünfte gefunden, die Ihrer Suche entsprechen. Weitere Unterkünfte finden Sie unter`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const view_more__on_partner_website = () => `Booking.com`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__ev_only = () => `Nur mit Ladestationen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range = () => `Suchbereich`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__text = () => `Entspricht der Entfernung zwischen Ihrer Route und den vorgeschlagenen interessanten Orten.`


/**
 * @param {{ value: NonNullable<unknown> }} params
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__filters__search_range__value = (params) => `Bis zu ${params.value} km`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois__see_all = () => `Mehr anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_subtitle = () => `Unsere Empfehlungen für Unterkünfte, Restaurants...`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__pois_title = () => `Sehenswürdigkeiten`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi__title = () => `Ideen für einen Zwischenstopp`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__available_accommodation = () => `An Ihrem Reiseziel stehen Unterkünfte zur Verfügung.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__arrival__see_accommodation_zone = () => `Auf der Karte anzeigen`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__error = () => `Die Sehenswürdigkeiten konnten nicht angezeigt werden.`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__image_alt = () => `Attraktive Gegend`


/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const zoi_card__see_on_map = () => `Auf der Karte anzeigen`
